import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useLoginMutation } from '../../Redux/Service/AuthApi';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import MyLogo from '../../Assets/PiTangent-dark.png';
import StyledDashboardLayout from '../style';
import { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

function Login() {

    const [showPass, setShowPass] = useState(false);
    const [login] = useLoginMutation();
    const navigate = useNavigate();
    console.log(showPass, "showPass")
    const validationSchema = Yup.object().shape({
        email: Yup.string().email('Invalid email').required('Email is required').max(50, "Email should be atmost 50 characters long"),
        password: Yup.string().required('Password is required').max(30, "Password should be atmost 30 characters long"),
    });

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            await login({ email: values.email, password: values.password });
            navigate('/dashboard');
        } catch (error) {
            toast.error('Login failed. Please try again.');
            console.error('Login failed', error);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <StyledDashboardLayout>
            <div className="hold-transition login-page">
                <div className="login-box">
                    <div className="card customCard p-4">
                        <div className="card-header text-center border-0">
                            <img
                                src={MyLogo}
                                alt="Logo"
                                className="logo"
                            />
                            {/* <span className="h1"><b>Pre </b>Sales</span> */}
                        </div>
                        <div className="card-body">
                            <p className="login-box-msg"></p>
                            <Formik
                                initialValues={{ email: '', password: '' }}
                                validationSchema={validationSchema}
                                onSubmit={handleSubmit}
                            >
                                {({ isSubmitting, touched, errors, handleBlur }) => (
                                    <Form autoComplete="off">
                                        <div className="input-group mb-3"
                                            style={{ position: 'relative' }}
                                        >
                                            <Field
                                                type="email"
                                                className={`form-control${touched.email && errors.email ? ' is-invalid' : ''}`}
                                                name="email"
                                                placeholder="Email"
                                                onBlur={handleBlur}
                                                autoComplete="off"
                                            />
                                            <ErrorMessage name="email" component="div" className="invalid-feedback" />
                                        </div>

                                        <div className="input-group mb-3" style={{ position: 'relative' }}>
                                            <Field
                                                type={showPass ? 'text' : 'password'}
                                                className={`form-control${touched.password && errors.password ? ' is-invalid' : ''}`}
                                                name="password"
                                                placeholder="Password"
                                                onBlur={handleBlur}
                                                autoComplete="off"
                                                style={{ paddingRight: '45px' }}
                                            />
                                            <span
                                                className="password-toggle-icon"
                                                style={{
                                                    position: 'absolute',
                                                    right: '12px',
                                                    top: '50%',
                                                    transform: 'translateY(-50%)',
                                                    cursor: 'pointer',
                                                    color: '#6c757d',
                                                    zIndex: 4
                                                }}
                                                onClick={() => setShowPass((prev) => !prev)}
                                            >
                                                {showPass ? <FaEyeSlash /> : <FaEye />}
                                            </span>
                                            <ErrorMessage name="password" component="div" className="invalid-feedback" />
                                        </div>

                                        <div className="row">
                                            <div className="col-7"></div>
                                            <div className="col-5">
                                                <button
                                                    type="submit"
                                                    className="btn commonBtn"
                                                    disabled={isSubmitting}
                                                >
                                                    {isSubmitting ? 'Logging in...' : 'Sign In'}
                                                </button>
                                            </div>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </StyledDashboardLayout>

    );
}

export default Login;
